<template>    
    <div class="modal fade" style="" id="AlertModal" tabindex="-1" role="dialog" aria-labelledby="AlertModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text text-danger" id="AlertModalLabel">เกิดข้อผิดพลาด</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <h3 class="text text-danger"> {{alertMessage.bodyMessage}} </h3>
            </div>
            <div class="modal-footer">                
                <button type="button" class="btn btn-secondary" data-dismiss="modal">ปิด</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {    
        props:{
            alertMessage:{},
        },
        data() {
            return {}
        },
        mounted() {
        },
        created(){
        },
        methods:{          
        },        
    
}
</script>